export default __webpack_public_path__ + "static/media/betterSmiley.552825d6.svg";